/**
 * Redux reducer for OTA updates
 */

import { IUpdateState } from '../../models/Update';
import * as UpdateActions from '../actions/updateAction';

const initialState: IUpdateState = {
  currentVersion: require('../../../package.json').version,
  availableUpdates: [],
  downloadProgress: {},
  updateStatus: 'none',
};

export const updateReducer = (state = initialState, action: any): IUpdateState => {
  switch (action.type) {
    case UpdateActions.CHECK_UPDATES_REQUEST:
      return {
        ...state,
        updateStatus: 'none',
      };

    case UpdateActions.CHECK_UPDATES_SUCCESS:
      return {
        ...state,
        availableUpdates: action.payload.availableUpdates,
        lastChecked: Date.now(),
        updateStatus: action.payload.availableUpdates.length > 0 ? 'available' : 'none',
      };

    case UpdateActions.CHECK_UPDATES_FAILURE:
      return {
        ...state,
        updateStatus: 'none',
      };

    case UpdateActions.DOWNLOAD_UPDATE_REQUEST:
      return {
        ...state,
        downloadProgress: {
          ...state.downloadProgress,
          [action.payload.update.type]: {
            type: action.payload.update.type,
            status: 'downloading',
            progress: 0,
          },
        },
      };

    case UpdateActions.DOWNLOAD_UPDATE_PROGRESS:
      return {
        ...state,
        downloadProgress: {
          ...state.downloadProgress,
          [action.payload.progress.type]: action.payload.progress,
        },
      };

    case UpdateActions.DOWNLOAD_UPDATE_SUCCESS:
      return {
        ...state,
        downloadProgress: {
          ...state.downloadProgress,
          [action.payload.update.type]: {
            type: action.payload.update.type,
            status: 'ready',
            progress: 100,
            downloadedPath: action.payload.downloadedPath,
          },
        },
        updateStatus: 'ready',
      };

    case UpdateActions.DOWNLOAD_UPDATE_FAILURE:
      return {
        ...state,
        downloadProgress: {
          ...state.downloadProgress,
          [action.payload.update.type]: {
            type: action.payload.update.type,
            status: 'failed',
            progress: 0,
            error: action.payload.error,
          },
        },
      };

    case UpdateActions.APPLY_UPDATES_REQUEST:
      return {
        ...state,
        updateStatus: 'installing',
      };

    case UpdateActions.APPLY_UPDATES_SUCCESS:
      return {
        ...state,
        availableUpdates: [],
        downloadProgress: {},
        updateStatus: 'none',
      };

    case UpdateActions.APPLY_UPDATES_FAILURE:
      return {
        ...state,
        updateStatus: 'failed',
      };

    case UpdateActions.DISMISS_UPDATE:
      return {
        ...state,
        availableUpdates: state.availableUpdates.filter(
          update => update.type !== action.payload.updateType
        ),
        updateStatus: state.availableUpdates.length > 1 ? 'available' : 'none',
      };

    case UpdateActions.RESET_UPDATE_STATE:
      return initialState;

    case UpdateActions.SET_CURRENT_VERSION:
      return {
        ...state,
        currentVersion: action.payload.version,
      };

    default:
      return state;
  }
};
